import React, { useState } from 'react';

const Contact = () => {
  const schoolPhone = '+2348119560710';
  const schoolPhoneDigits = '2348119560710';

  const [formData, setFormData] = useState({
    senderName: '',
    senderEmail: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${API_ENDPOINTS.MESSAGES}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Message sent successfully! We\'ll get back to you soon.' });
        setFormData({
          senderName: '',
          senderEmail: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus({ type: 'error', message: result.error || 'Failed to send message. Please try again.' });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitStatus({ type: 'error', message: 'Network error. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGetDirections = () => {
    // School coordinates: 6.243759, 6.676282
    const schoolLat = 6.243759;
    const schoolLng = 6.676282;

    // Open Google Maps with directions to school location
    // Google Maps will automatically use user's current location as starting point
    const mapsUrl = `https://www.google.com/maps/dir//${schoolLat},${schoolLng}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <section id="contact" className="relative py-16 px-6 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 via-purple-400/10 to-pink-400/10 animate-pulse"></div>
        <div className="absolute top-10 left-10 w-32 h-32 bg-blue-200 rounded-full blur-xl opacity-30 animate-bounce"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-purple-200 rounded-full blur-xl opacity-20 animate-bounce delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-pink-200 rounded-full blur-xl opacity-25 animate-bounce delay-500"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h3 className="text-5xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-4 animate-fade-in">
            Get In Touch
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Have questionsLoading Need assistanceLoading Send us a message and our team will respond promptly!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Information Card */}
          <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/20 hover:shadow-3xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="mb-8">
              <h4 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <span className="w-3 h-3 bg-green-500 rounded-full mr-3 animate-pulse"></span>
                Contact Information
              </h4>
              <div className="space-y-6">
                <div className="flex items-center space-x-4 p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl border-l-4 border-blue-500">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">GPS</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">Location</p>
                    <p className="text-gray-600 mb-3">Elder Isibor Street off New General Hospital Road, along Okpanam Road, Asaba</p>
                    <button
                      onClick={handleGetDirections}
                      className="px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 transform hover:scale-105 bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg"
                    >
                      <div className="flex items-center">
                        <span className="mr-2">🧭</span>
                        Get Directions
                      </div>
                    </button>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gradient-to-r from-green-50 to-green-100 rounded-xl border-l-4 border-green-500">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">Contact</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">Phone</p>
                    <p className="text-gray-600 mb-3">{schoolPhone}</p>
                    <button
                      onClick={() => window.location.href = `tel:${schoolPhone}`}
                      className="px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 transform hover:scale-105 bg-green-600 hover:bg-green-700 text-white shadow-md hover:shadow-lg"
                    >
                      <div className="flex items-center">
                        <span className="mr-2">Contact</span>
                        Call Now
                      </div>
                    </button>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gradient-to-r from-purple-50 to-purple-100 rounded-xl border-l-4 border-purple-500">
                  <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">💬</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">WhatsApp</p>
                    <p className="text-gray-600 mb-3">{schoolPhone}</p>
                    <a
                      href={`https://wa.me/${schoolPhoneDigits}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 transform hover:scale-105 bg-purple-600 hover:bg-purple-700 text-white shadow-md hover:shadow-lg no-underline"
                    >
                      <div className="flex items-center">
                        <span className="mr-2">💬</span>
                        Chat on WhatsApp
                      </div>
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4 p-4 bg-gradient-to-r from-pink-50 to-pink-100 rounded-xl border-l-4 border-pink-500">
                  <div className="w-12 h-12 bg-pink-500 rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">✉️</span>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-gray-800">Email</p>
                    <p className="text-gray-600 mb-3">info@creativetown.ng</p>
                    <button
                      onClick={() => window.location.href = 'mailto:info@creativetown.ng'}
                      className="px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 transform hover:scale-105 bg-pink-600 hover:bg-pink-700 text-white shadow-md hover:shadow-lg"
                    >
                      <div className="flex items-center">
                        <span className="mr-2">✉️</span>
                        Send Email
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media Links */}
            <div>
              <h4 className="text-xl font-bold text-gray-800 mb-4">Follow Us</h4>
              <div className="flex space-x-4">
                <a
                  href="https://facebook.com/creativetown"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-blue-600 hover:bg-blue-700 rounded-full flex items-center justify-center text-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                >
                  <span className="text-xl">f</span>
                </a>
                <a
                  href="https://instagram.com/creativetown2024"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-full flex items-center justify-center text-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                >
                  <span className="text-xl">📷</span>
                </a>
                <a
                  href="https://tiktok.com/@creative.town.bil2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-black hover:bg-gray-800 rounded-full flex items-center justify-center text-white transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                >
                  <span className="text-xl">🎵</span>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form Card */}
          <div className="bg-white/90 backdrop-blur-lg rounded-3xl shadow-2xl p-8 border border-white/20 hover:shadow-3xl transition-all duration-500">
            <h4 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <span className="w-3 h-3 bg-blue-500 rounded-full mr-3 animate-pulse"></span>
              Send us a Message
            </h4>

            {/* Status Messages */}
            {submitStatus && (
              <div className={`mb-6 p-4 rounded-xl border-l-4 animate-fade-in ${
                submitStatus.type === 'success'
                  ? 'bg-green-50 border-green-500 text-green-800'
                  : 'bg-red-50 border-red-500 text-red-800'
              }`}>
                <div className="flex items-center">
                  <span className="mr-2">
                    {submitStatus.type === 'success' ? '?' : 'X'}
                  </span>
                  {submitStatus.message}
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="senderName"
                    value={formData.senderName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-all duration-300 bg-gray-50 hover:bg-white"
                    placeholder="Enter your full name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="senderEmail"
                    value={formData.senderEmail}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-all duration-300 bg-gray-50 hover:bg-white"
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-all duration-300 bg-gray-50 hover:bg-white"
                  placeholder="What's this about?"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message *
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows={6}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:outline-none transition-all duration-300 bg-gray-50 hover:bg-white resize-none"
                  placeholder="Tell us how we can help you..."
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-4 px-6 rounded-xl font-semibold text-white text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none ${
                  isSubmitting
                    ? 'bg-gray-400'
                    : 'bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 hover:from-blue-700 hover:via-purple-700 hover:to-pink-700'
                }`}
              >
                {isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Sending...
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <span className="mr-2">✈️</span>
                    Send Message
                  </div>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 right-20 w-16 h-16 bg-yellow-200 rounded-full opacity-20 animate-bounce delay-300"></div>
      <div className="absolute bottom-32 left-20 w-12 h-12 bg-green-200 rounded-full opacity-30 animate-bounce delay-700"></div>
    </section>
  );
};

export default Contact;
